let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8Kivm"), load("hUIij"), load("6Up0b"), load("lnKog"), load("iQ0Jm"), load("5n2uM")]).then(() => parcelRequire('bexnX'));